var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "single-template card" }, [
    _c(
      "div",
      { staticClass: "card-header card-image", style: _vm.templateStyle },
      [
        _vm.showDeleteButton
          ? _c(
              "inline-prompt",
              {
                ref: "prompt",
                staticClass:
                  "text-danger card-delete delete-template clickable",
                attrs: {
                  "action-type": "delete",
                  "confirmation-text": "i18n|templates.messages.removeTemplate",
                },
                on: { accept: _vm.handleDelete },
              },
              [
                _c("i", {
                  staticClass: "fa fa-times",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "card-body reduced-padding" }, [
      _c(
        "p",
        {
          staticClass: "card-title text-center searchable text-truncate",
          class: { "text-danger": _vm.deleted },
        },
        [_vm._v("\n      " + _vm._s(_vm.templateName) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.actions || _vm.showDisabledActions
        ? _c(
            "div",
            {
              staticClass:
                "card-actions text-center d-flex flex-row justify-content-center",
            },
            [
              !_vm.category
                ? _c("div", { staticClass: "not-predefined-actions" }, [
                    _vm.selectPage
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "clickable btn btn-sm btn-primary template-btn-select template-action-btn",
                            attrs: {
                              disabled: _vm.deleted || _vm.showDisabledActions,
                            },
                            on: { click: _vm.handleSelect },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.words.select")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _c(
                          "a",
                          {
                            staticClass:
                              "clickable btn btn-sm btn-primary template-btn-edit template-action-btn text-capitalize",
                            class: { disabled: _vm.isEditDisabled },
                            attrs: { disabled: _vm.isEditDisabled },
                            on: { click: _vm.handleEdit },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.words.edit")) +
                                "\n        "
                            ),
                          ]
                        ),
                  ])
                : _c(
                    "div",
                    {
                      staticClass: "predefined-actions",
                      on: { click: _vm.handleDuplicate },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "clickable btn btn-sm btn-primary template-btn-create template-action-btn",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("templates.actions.duplicate")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "clickable btn btn-sm btn-white template-btn-preview",
                  on: { click: _vm.handlePreview },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("templates.actions.preview")) +
                      "\n      "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }